export class BoardApprovalCollectionReferralResultDto {
    collectionItem: string;
    notes: string;
}
